module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    staticClass: "app-layout",
    class: {
      about: _vm.isAbout
    },
    attrs: {
      "id": "app",
      "mobile": _vm.mobile,
      "mobMenuShow": _vm.mobMenuShow
    }
  }, [_c('header-app'), _vm._v(" "), _c('div', {
    staticClass: "background-container"
  }, [_c('div', {
    staticClass: "bg-center valign"
  }, [_c('Spiral')], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-bottom",
    class: {
      hide: _vm.isHidden, strong: _vm.isStrong
    }
  }, [_c('p', {
    staticClass: "mobile-hidden"
  }, [_vm._v("* Шендеров Б.А. Метабиотики: новая идея или естественное развитие пробиотической концепции:\n                Материалы симпозиума «Современное состояние и перспективы развития концепции пробиотикотерапии».")]), _vm._v(" "), _c('p', {
    class: {
      hidden: !_vm.isAbout
    }
  }, [_vm._v("** Инструкция по применению БАКТИСТАТИН®")]), _vm._v(" "), _c('p', [_vm._v("Москва, 30.09.2013.  СГР № RU.77.99.88.003. E.010166.11.14 от 05.11.2014 г. ")]), _vm._v(" "), _c('p', [_vm._v("АО «НИЖФАРМ» 119017, Москва, ул. Большая Ордынка, 44с4")]), _vm._v(" "), _c('DiscD', {
    staticClass: "mobile-hidden"
  }), _vm._v(" "), _c('Disc', {
    staticClass: "desktop-hidden"
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fades"
    }
  }, [(!_vm.mobMenuShow) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), _c('main-nav', {
    attrs: {
      "mobMenuShow": _vm.mobMenuShow,
      "mobMenuToggle": _vm.mobMenuToggle,
      "mobile": _vm.mobile
    }
  }), _vm._v(" "), (_vm.mobile) ? _c('div', {
    staticClass: "rotate-message valign desktop-hidden"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/rotate.png",
      "alt": "Rotate"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Пожалуйста, переверните устройство")])]) : _vm._e(), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156f50c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 95
// module chunks = 0